/**
 * Redux Action Types for Data Categorization
 *
 * Defines all action type constants used throughout the application
 * for managing data categorization state.
 *
 * @author Development Team
 * @version 1.0
 */

// ==================== CATEGORIES ====================

// Fetch all categories
export const GET_ALL_DATA_CATEGORIES = 'GET_ALL_DATA_CATEGORIES';
export const GET_ALL_DATA_CATEGORIES_SUCCESS = 'GET_ALL_DATA_CATEGORIES_SUCCESS';
export const GET_ALL_DATA_CATEGORIES_ERROR = 'GET_ALL_DATA_CATEGORIES_ERROR';

// Fetch single category
export const GET_DATA_CATEGORY = 'GET_DATA_CATEGORY';
export const GET_DATA_CATEGORY_SUCCESS = 'GET_DATA_CATEGORY_SUCCESS';
export const GET_DATA_CATEGORY_ERROR = 'GET_DATA_CATEGORY_ERROR';

// Create category
export const CREATE_DATA_CATEGORY = 'CREATE_DATA_CATEGORY';
export const CREATE_DATA_CATEGORY_SUCCESS = 'CREATE_DATA_CATEGORY_SUCCESS';
export const CREATE_DATA_CATEGORY_ERROR = 'CREATE_DATA_CATEGORY_ERROR';

// Update category
export const UPDATE_DATA_CATEGORY = 'UPDATE_DATA_CATEGORY';
export const UPDATE_DATA_CATEGORY_SUCCESS = 'UPDATE_DATA_CATEGORY_SUCCESS';
export const UPDATE_DATA_CATEGORY_ERROR = 'UPDATE_DATA_CATEGORY_ERROR';

// Delete category
export const DELETE_DATA_CATEGORY = 'DELETE_DATA_CATEGORY';
export const DELETE_DATA_CATEGORY_SUCCESS = 'DELETE_DATA_CATEGORY_SUCCESS';
export const DELETE_DATA_CATEGORY_ERROR = 'DELETE_DATA_CATEGORY_ERROR';

// Change category status
export const CHANGE_CATEGORY_STATUS = 'CHANGE_CATEGORY_STATUS';
export const CHANGE_CATEGORY_STATUS_SUCCESS = 'CHANGE_CATEGORY_STATUS_SUCCESS';
export const CHANGE_CATEGORY_STATUS_ERROR = 'CHANGE_CATEGORY_STATUS_ERROR';

// Search categories
export const SEARCH_CATEGORIES = 'SEARCH_CATEGORIES';
export const SEARCH_CATEGORIES_SUCCESS = 'SEARCH_CATEGORIES_SUCCESS';
export const SEARCH_CATEGORIES_ERROR = 'SEARCH_CATEGORIES_ERROR';

// Get audit log
export const GET_AUDIT_LOG = 'GET_AUDIT_LOG';
export const GET_AUDIT_LOG_SUCCESS = 'GET_AUDIT_LOG_SUCCESS';
export const GET_AUDIT_LOG_ERROR = 'GET_AUDIT_LOG_ERROR';

// ==================== RULES MANAGEMENT ====================

// Team management (legacy — kept for backward compat)
export const ADD_TEAM = 'ADD_TEAM';
export const ADD_TEAM_SUCCESS = 'ADD_TEAM_SUCCESS';
export const ADD_TEAM_ERROR = 'ADD_TEAM_ERROR';

export const REMOVE_TEAM = 'REMOVE_TEAM';
export const REMOVE_TEAM_SUCCESS = 'REMOVE_TEAM_SUCCESS';
export const REMOVE_TEAM_ERROR = 'REMOVE_TEAM_ERROR';

export const UPDATE_TEAM_MEMBERS = 'UPDATE_TEAM_MEMBERS';

// Team management (new API-backed)
export const CREATE_TEAM = 'CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = 'CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_ERROR = 'CREATE_TEAM_ERROR';

export const DELETE_TEAM = 'DELETE_TEAM';
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_ERROR = 'DELETE_TEAM_ERROR';

export const GET_ALL_TEAMS_DETAILED = 'GET_ALL_TEAMS_DETAILED';
export const GET_ALL_TEAMS_DETAILED_SUCCESS = 'GET_ALL_TEAMS_DETAILED_SUCCESS';
export const GET_ALL_TEAMS_DETAILED_ERROR = 'GET_ALL_TEAMS_DETAILED_ERROR';

export const ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER';
export const ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS';
export const ADD_TEAM_MEMBER_ERROR = 'ADD_TEAM_MEMBER_ERROR';

export const REMOVE_TEAM_MEMBER = 'REMOVE_TEAM_MEMBER';
export const REMOVE_TEAM_MEMBER_SUCCESS = 'REMOVE_TEAM_MEMBER_SUCCESS';
export const REMOVE_TEAM_MEMBER_ERROR = 'REMOVE_TEAM_MEMBER_ERROR';

export const GET_MY_TEAMS = 'GET_MY_TEAMS';
export const GET_MY_TEAMS_SUCCESS = 'GET_MY_TEAMS_SUCCESS';
export const GET_MY_TEAMS_ERROR = 'GET_MY_TEAMS_ERROR';

export const CHECK_TEAM_ACCESS = 'CHECK_TEAM_ACCESS';
export const CHECK_TEAM_ACCESS_SUCCESS = 'CHECK_TEAM_ACCESS_SUCCESS';
export const CHECK_TEAM_ACCESS_ERROR = 'CHECK_TEAM_ACCESS_ERROR';

// Fetch all rules
export const GET_ALL_RULES = 'GET_ALL_RULES';
export const GET_ALL_RULES_SUCCESS = 'GET_ALL_RULES_SUCCESS';
export const GET_ALL_RULES_ERROR = 'GET_ALL_RULES_ERROR';

// Fetch single rule
export const GET_RULE_BY_ID = 'GET_RULE_BY_ID';
export const GET_RULE_BY_ID_SUCCESS = 'GET_RULE_BY_ID_SUCCESS';
export const GET_RULE_BY_ID_ERROR = 'GET_RULE_BY_ID_ERROR';

// Create rule
export const CREATE_RULE = 'CREATE_RULE';
export const CREATE_RULE_SUCCESS = 'CREATE_RULE_SUCCESS';
export const CREATE_RULE_ERROR = 'CREATE_RULE_ERROR';

// Update rule
export const UPDATE_RULE = 'UPDATE_RULE';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';
export const UPDATE_RULE_ERROR = 'UPDATE_RULE_ERROR';

// Delete rule
export const DELETE_RULE = 'DELETE_RULE';
export const DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';
export const DELETE_RULE_ERROR = 'DELETE_RULE_ERROR';

// Toggle rule status
export const TOGGLE_RULE_STATUS = 'TOGGLE_RULE_STATUS';
export const TOGGLE_RULE_STATUS_SUCCESS = 'TOGGLE_RULE_STATUS_SUCCESS';
export const TOGGLE_RULE_STATUS_ERROR = 'TOGGLE_RULE_STATUS_ERROR';

// ==================== BATCH PROCESSING ====================

// Upload batch file
export const UPLOAD_BATCH_FILE = 'UPLOAD_BATCH_FILE';
export const UPLOAD_BATCH_FILE_PROGRESS = 'UPLOAD_BATCH_FILE_PROGRESS';
export const UPLOAD_BATCH_FILE_SUCCESS = 'UPLOAD_BATCH_FILE_SUCCESS';
export const UPLOAD_BATCH_FILE_ERROR = 'UPLOAD_BATCH_FILE_ERROR';

// Get batch status
export const GET_BATCH_STATUS = 'GET_BATCH_STATUS';
export const GET_BATCH_STATUS_SUCCESS = 'GET_BATCH_STATUS_SUCCESS';
export const GET_BATCH_STATUS_ERROR = 'GET_BATCH_STATUS_ERROR';

// Cancel batch
export const CANCEL_BATCH = 'CANCEL_BATCH';
export const CANCEL_BATCH_SUCCESS = 'CANCEL_BATCH_SUCCESS';
export const CANCEL_BATCH_ERROR = 'CANCEL_BATCH_ERROR';

// Get batch results
export const GET_BATCH_RESULTS = 'GET_BATCH_RESULTS';
export const GET_BATCH_RESULTS_SUCCESS = 'GET_BATCH_RESULTS_SUCCESS';
export const GET_BATCH_RESULTS_ERROR = 'GET_BATCH_RESULTS_ERROR';

// Get recent batches
export const GET_RECENT_BATCHES = 'GET_RECENT_BATCHES';
export const GET_RECENT_BATCHES_SUCCESS = 'GET_RECENT_BATCHES_SUCCESS';
export const GET_RECENT_BATCHES_ERROR = 'GET_RECENT_BATCHES_ERROR';

// Persist selected team across tabs
export const SET_SELECTED_TEAM = 'SET_SELECTED_TEAM';

// Re-process batch (ALL or FAILED_ONLY)
export const REPROCESS_BATCH = 'REPROCESS_BATCH';
export const REPROCESS_BATCH_SUCCESS = 'REPROCESS_BATCH_SUCCESS';
export const REPROCESS_BATCH_ERROR = 'REPROCESS_BATCH_ERROR';

// ==================== RESULT VALIDATION ====================

// Validate result
export const VALIDATE_RESULT = 'VALIDATE_RESULT';
export const VALIDATE_RESULT_SUCCESS = 'VALIDATE_RESULT_SUCCESS';
export const VALIDATE_RESULT_ERROR = 'VALIDATE_RESULT_ERROR';

// Bulk validate results
export const BULK_VALIDATE_RESULTS = 'BULK_VALIDATE_RESULTS';
export const BULK_VALIDATE_RESULTS_SUCCESS = 'BULK_VALIDATE_RESULTS_SUCCESS';
export const BULK_VALIDATE_RESULTS_ERROR = 'BULK_VALIDATE_RESULTS_ERROR';

// ==================== EXCEL OPERATIONS ====================

// Ingest Excel
export const INGEST_EXCEL_FILE = 'INGEST_EXCEL_FILE';
export const INGEST_EXCEL_FILE_SUCCESS = 'INGEST_EXCEL_FILE_SUCCESS';
export const INGEST_EXCEL_FILE_ERROR = 'INGEST_EXCEL_FILE_ERROR';

// Export to Excel
export const EXPORT_TO_EXCEL = 'EXPORT_TO_EXCEL';
export const EXPORT_TO_EXCEL_SUCCESS = 'EXPORT_TO_EXCEL_SUCCESS';
export const EXPORT_TO_EXCEL_ERROR = 'EXPORT_TO_EXCEL_ERROR';

// ==================== DATA ITEMS ====================

// Get all data items
export const GET_ALL_DATA_ITEMS = 'GET_ALL_DATA_ITEMS';
export const GET_ALL_DATA_ITEMS_SUCCESS = 'GET_ALL_DATA_ITEMS_SUCCESS';
export const GET_ALL_DATA_ITEMS_ERROR = 'GET_ALL_DATA_ITEMS_ERROR';

// Get data item by ID
export const GET_DATA_ITEM_BY_ID = 'GET_DATA_ITEM_BY_ID';
export const GET_DATA_ITEM_BY_ID_SUCCESS = 'GET_DATA_ITEM_BY_ID_SUCCESS';
export const GET_DATA_ITEM_BY_ID_ERROR = 'GET_DATA_ITEM_BY_ID_ERROR';

// Categorize data item
export const CATEGORIZE_DATA_ITEM = 'CATEGORIZE_DATA_ITEM';
export const CATEGORIZE_DATA_ITEM_SUCCESS = 'CATEGORIZE_DATA_ITEM_SUCCESS';
export const CATEGORIZE_DATA_ITEM_ERROR = 'CATEGORIZE_DATA_ITEM_ERROR';

// Recategorize data item
export const RECATEGORIZE_DATA_ITEM = 'RECATEGORIZE_DATA_ITEM';
export const RECATEGORIZE_DATA_ITEM_SUCCESS = 'RECATEGORIZE_DATA_ITEM_SUCCESS';
export const RECATEGORIZE_DATA_ITEM_ERROR = 'RECATEGORIZE_DATA_ITEM_ERROR';

// ==================== TEAMS ====================

// Fetch all teams
export const LOAD_TEAMS = 'LOAD_TEAMS';
export const LOAD_TEAMS_SUCCESS = 'LOAD_TEAMS_SUCCESS';
export const LOAD_TEAMS_ERROR = 'LOAD_TEAMS_ERROR';

// ==================== ATTESTATION ====================

// Attest single result (accept / deny)
export const ATTEST_RESULT = 'ATTEST_RESULT';
export const ATTEST_RESULT_SUCCESS = 'ATTEST_RESULT_SUCCESS';
export const ATTEST_RESULT_ERROR = 'ATTEST_RESULT_ERROR';

// Bulk attest results
export const BULK_ATTEST_RESULTS = 'BULK_ATTEST_RESULTS';
export const BULK_ATTEST_RESULTS_SUCCESS = 'BULK_ATTEST_RESULTS_SUCCESS';
export const BULK_ATTEST_RESULTS_ERROR = 'BULK_ATTEST_RESULTS_ERROR';

// Accept ALL categorized results for a batch (server-side, no pagination limit)
export const ACCEPT_ALL_BATCH = 'ACCEPT_ALL_BATCH';
export const ACCEPT_ALL_BATCH_SUCCESS = 'ACCEPT_ALL_BATCH_SUCCESS';
export const ACCEPT_ALL_BATCH_ERROR = 'ACCEPT_ALL_BATCH_ERROR';

// ==================== UI STATE ====================

// UI state actions
export const CLEAR_DATA_CATEGORY_ERROR = 'CLEAR_DATA_CATEGORY_ERROR';
export const CLEAR_SUCCESS_MESSAGE = 'CLEAR_SUCCESS_MESSAGE';
export const SET_LOADING = 'SET_LOADING';

// Pagination and filtering
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
